/**
 * Indique si le module POS autorise l'accès aux données des autres commerces
 * (paramètre `access_ca_other`).
 *
 * @param {Object} authParam - Contexte d'authentification (IsAuthContext)
 * @returns {boolean}
 */
export const hasAccessCaOther = (authParam) => {
    const modulePos = authParam.modules.find(value => value.name == 'pos')
    const param = modulePos?.params?.access_ca_other
    return !!(param && param.active)
}

/**
 * Liste les sections proposables dans le sélecteur "commerce" des historiques,
 * hors section courante (déjà proposée en première option).
 * - access_ca_other actif : toutes les sections de la company
 * - sinon : uniquement les sections partageant une other_company avec la section courante
 *
 * @param {Array} allSections - Sections renvoyées par api/section (avec other_company)
 * @param {Array} otherCompanyId - Ids des other_company de la section courante
 * @param {number|string} posid - Id de la section courante
 * @param {boolean} accessCaOther - Résultat de hasAccessCaOther
 * @returns {Array}
 */
export const getSelectableSections = (allSections, otherCompanyId, posid, accessCaOther) => {
    return allSections.filter(section => {
        if (section.id == posid) return false
        if (accessCaOther) return true
        return (section.other_company || []).some(item => otherCompanyId.includes(item.id))
    })
}
